import {
  Box,
  CircularProgress,
  Divider,
  Paper,
  Toolbar,
  Typography,
  makeStyles,
} from '@material-ui/core'
import { useEffect, useState } from 'react'
import { buscaPrograma, setProgramaAberto } from '../api'

const useStyles = makeStyles((theme) => ({
  toolbar: {
    display: 'flex',
    minHeight: 32,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  subtitle: {
    flex: '1',
  },
}))

const Programa = ({ children, codigo, ferramentas }) => {
  const classes = useStyles()
  const [loading, setLoading] = useState(true)
  const [dadosPrograma, setDadosPrograma] = useState({
    codigo: '',
    titulo: '',
    subtitulo: '',
    tempo: 0,
  })

  useEffect(() => {
    setProgramaAberto(codigo)
    buscaPrograma(codigo)
      .then((res) => setDadosPrograma(res.dados || {}))
      .then(() => setLoading(false))
    return () => {
      setProgramaAberto('')
    }
  }, [codigo])

  if (loading)
    return (
      <Box style={{ display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    )
  return (
    <>
      <Paper
        style={{ borderRadius: 7, borderColor: 'white' }}
        variant="outlined"
      >
        <Toolbar className={classes.toolbar}>
          <Typography gutterBottom>
            {dadosPrograma.titulo} - <small>{dadosPrograma.subtitulo}</small>
          </Typography>
          <Typography className={classes.subtitle}></Typography>
          {ferramentas}
        </Toolbar>
        <Divider />
        <Box padding={2}>{children}</Box>
      </Paper>
    </>
  )
}

export default Programa
